const radius: IRadius = {
  border: '16px',
  card: '16px',
}

export default radius
